export { default } from "./AdminConsoleBasePage";
